import { Component } from 'opus-angular-seed-core';
import template from './template.html';

const DEFAULT_PAGE_SIZE = 25;
@Component({
    bindings: {
        classifiers: '=',
        sites: '=',
        course: '=',
        trainingFields: '='
    },
    template
})
export default class {
    constructor ($state, $window, ListFactory, CourseResource, COURSE_STATUS_TYPE_ENUM, $translate,
                 AuthResource, TokenService, ReportService) {
        this.$state = $state;
        this.$window = $window;
        this.courseResource = CourseResource;
        this.$translate = $translate;
        this.AuthResource = AuthResource;
        this.TokenService = TokenService;
        this.ReportService = ReportService;
        this.defaultCourse = Object.assign({}, this.course);
        this.displayCourseName = this.getCourseName(this.course);
        this.COURSE_STATUS_TYPE_ENUM = COURSE_STATUS_TYPE_ENUM;
        this.filterParams = {};

        this.currentState = $state.current;
        this.courseResultsStateName = 'authorized.reports.courseresults.overview';
        this.breadcrumbs = [
            { label: this.$translate.instant('reports.Courses results'), state: this.courseResultsStateName },
            { label: this.$translate.instant('reports.Learner progress'), state: null }
        ];

        this.list = ListFactory.createWithPagination(CourseResource.learnerProgress.bind(CourseResource));
        this.list.pagination.perPage = DEFAULT_PAGE_SIZE;
        this.list.lastQuery.pageSize = DEFAULT_PAGE_SIZE;
    }

    getCourseName (course) {
        if (!course) {
            return '';
        }
        if (course.activeI18n && course.activeI18n.name) {
            return course.activeI18n.name;
        }
        return course.name || '';
    }

    updateDisplayCourseName () {
        this.displayCourseName = this.getCourseName(this.course);
    }

    exportCsv () {
        const params = this.filterParams || {};
        const filter = {
            courseId: params.courseId,
            employeeName: params.employeeName,
            from: params.from,
            to: params.to,
            'status[]': params.status,
            'trainingField[]': params.trainingField,
            'employeeStatus[]': params.employeeStatus,
            'employeeIds[]': params.employeeIds,
            'directManagerIds[]': params.directManagerIds,
            'siteIds[]': params.siteIds,
            'departmentIds[]': params.departmentIds,
            'roleIds[]': params.roleIds,
            'levelIds[]': params.levelIds,
            'participationTypes[]': params.participationTypes
        };
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = this.ReportService.buildQueryString(filter);
                const lang = this.TokenService.getActiveLanguage(true);
                const url = `${SEED_CORE.ENV.API_URL}course/course/learner-progress-export?tacToken=${token}&${qs}&_lang=${lang}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/courseresults/learnerProgress/index.js